import { useState, useEffect } from "react";
import { BuilderComponent } from "@builder.io/react";
import { builderClient } from "../../utils/builder";
import useNewOrReturningCustomer from "@/helpers/hooks/useNewOrReturningCustomer";
import { removeTargetAttr } from "@/helpers/generalHelper";
import { getUserTierInfo } from "@/helpers/yotpoHelper";

const MyImpactContentTile = () => {
  const [builderContentJson, setBuilderContentJson] = useState(null);

  const newOrReturningCustomer = useNewOrReturningCustomer();
  const customerRewardLevel =  getUserTierInfo();

  useEffect(() => {
    if (newOrReturningCustomer) {
      builderClient
        .get("my-impact-content-tile", {
          userAttributes: {
            urlPath: location.pathname,
            customerType: newOrReturningCustomer,
            rewardLevel: customerRewardLevel
          },
        })
        .promise()
        .then((data) => {
          setBuilderContentJson(data);
          if (typeof data == "undefined") {
            reportError("my-impact-content-tile builder module not found");
          }
        });
    }
    if (builderContentJson) {
      removeTargetAttr();
    }
  }, [newOrReturningCustomer, customerRewardLevel]);

  return (
    <BuilderComponent
      model="my-impact-content-tile"
      content={builderContentJson}
    />
  );
};

export default MyImpactContentTile;
